// A giraffe, modelled facing +X: a tan spotted body on tall legs, a very long
// sloping neck and a small horned head. Ported 1:1 from age-of-mcp's classic
// giraffe.ts, restoring its leg loop, body/neck/head and the spot loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.07, 0.05], [0.07, -0.05], [-0.07, 0.05], [-0.07, -0.05]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.011, 0.009, 0.32, 5),
      color: "#d8b260", position: [x!, 0.16, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.075, 0), color: "#e0bc6e",
      position: [0, 0.32, 0], scale: [1.7, 1, 0.9] },                // body
    { geometry: new THREE.CylinderGeometry(0.026, 0.034, 0.34, 6), color: "#e0bc6e",
      position: [0.12, 0.52, 0], rotation: [0, 0, -0.55] },          // long neck
    { geometry: new THREE.BoxGeometry(0.07, 0.045, 0.04), color: "#e6c47a",
      position: [0.21, 0.69, 0] },                                   // head
    { geometry: new THREE.ConeGeometry(0.012, 0.026, 4), color: "#caa050",
      position: [0.235, 0.71, 0], rotation: [0, 0, -Math.PI / 2] },   // muzzle
    { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.025, 4), color: "#7a5a2e",
      position: [0.19, 0.725, 0.014] },                             // ossicone
    { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.025, 4), color: "#7a5a2e",
      position: [0.19, 0.725, -0.014] },
  );
  // A few darker spots over the body and neck.
  for (const [sx, sy, sz] of [[0.02, 0.34, 0.06], [-0.04, 0.31, -0.05],
                              [0.1, 0.46, 0.04], [0.04, 0.3, 0.07]]) {
    parts.push({ geometry: new THREE.IcosahedronGeometry(0.022, 0),
      color: "#a87a34", position: [sx!, sy!, sz!], scale: [1, 1, 0.3] });
  }
  return parts;
}

export const giraffe = defineModel({
  id: "giraffe",
  scale: 2.66, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Giraffe",
  tags: ["creature","giraffe","low-poly","age-of-mcp","classic"],
  summary: "Low-poly giraffe.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.2,
  parts: () => partsFor(),
  animations: [],
});
